import api from "./Api";

class EmitenteRestricaoService {
  GetEmitenteRestricao(payload) {
    return api.get("/v1/emitenteRestricao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostEmitenteRestricao(payload) {
    return api.post("/v1/emitenteRestricao/", payload).then((response) => {
      return response.data;
    });
  }

  PutEmitenteRestricao(payload) {
    return api.put("/v1/emitenteRestricao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteEmitenteRestricao(payload) {
    return api.delete("/v1/emitenteRestricao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetEmitenteRestricaoOData(payload) {
    return api.get("/OData/EmitenteRestricao" + payload).then((response) => {
      return response.data;
    });
  }

  LiberarAcesso(payload) {
    return api
      .get("/v1/EmitenteRestricao/LiberarAcesso" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new EmitenteRestricaoService();
